import { z } from 'zod';

// User Roles
export const UserRoleSchema = z.enum(['SuperAdmin', 'Admin', 'Cashier']);
export type UserRole = z.infer<typeof UserRoleSchema>;

// Donation Types (will be configurable by SuperAdmin)
export const DonationTypeSchema = z.enum([
  'Zakat',
  'Sadaqah',
  'Fidya',
  'Kaffarah',
  'Qurbani',
  'General',
  'Other'
]);
export type DonationType = z.infer<typeof DonationTypeSchema>;

// Expense Types (will be configurable by SuperAdmin)
export const ExpenseTypeSchema = z.enum([
  'Operational',
  'Administrative',
  'Infrastructure',
  'Charitable',
  'Other'
]);
export type ExpenseType = z.infer<typeof ExpenseTypeSchema>;

// Donation Status
export const DonationStatusSchema = z.enum([
  'pending',
  'confirmed',
  'failed',
  'void'
]);
export type DonationStatus = z.infer<typeof DonationStatusSchema>;

// Update Types
export const UpdateTypeSchema = z.enum(['update', 'delete']);
export type UpdateType = z.infer<typeof UpdateTypeSchema>;

// Transaction Types
export const TransactionTypeSchema = z.enum(['credit', 'debit', 'transfer']);
export type TransactionType = z.infer<typeof TransactionTypeSchema>;

// Relation Types
export const RelationTypeSchema = z.enum(['Father', 'Husband', 'Other']);
export type RelationType = z.infer<typeof RelationTypeSchema>;

// Referral Types
export const ReferralTypeSchema = z.enum(['self', 'family']);
export type ReferralType = z.infer<typeof ReferralTypeSchema>;

// Donor Reference Types
export const DonorRefTypeSchema = z.enum(['permanent', 'guest']);
export type DonorRefType = z.infer<typeof DonorRefTypeSchema>;

// Report Languages
export const ReportLanguageSchema = z.enum(['en', 'ur']);
export type ReportLanguage = z.infer<typeof ReportLanguageSchema>;

// Font Sizes
export const FontSizeSchema = z.enum(['sm', 'md', 'lg']);
export type FontSize = z.infer<typeof FontSizeSchema>;

// Themes
export const ThemeSchema = z.enum(['light', 'dark', 'system']);
export type Theme = z.infer<typeof ThemeSchema>; 